export default __webpack_public_path__ + "static/media/FO.8a24094a.svg";